import React from 'react'
import { PhotoProvider, PhotoView } from 'react-photo-view'

const adsImage = require("./../assets/images/mainPageImage/advertising.png")
const guideImages = [
    require("./../assets/images/advertisingGuid/1.jpg"),
    require("./../assets/images/advertisingGuid/2.jpg"),
    require("./../assets/images/advertisingGuid/3.jpg"),
    require("./../assets/images/advertisingGuid/4.jpg"),
]

const AdvertisingDescription = () => (
    <section id="ads" className="tint">
        <div className="wrap">
            <div className="split">
                <div>
                    <span className="kicker">تبلیغات</span>
                    <h2>تجربه <span style={{ color: "var(--primary)" }}>رشد و رونق</span> کسب‌وکار در فضای آنلاین روستا</h2>
                    <p>تبلیغات «ده‌وند» یک راه سریع و پربازده برای جذب مخاطب و فروش محصولات و خدمات شماست.</p>
                </div>
                <img src={adsImage} alt="تبلیغات در ده‌وند" />
            </div>

            <div className="title" style={{ marginTop: 50 }}>
                <small>نحوهٔ عملکرد</small>
                <h2>تبلیغات «ده‌وند» چطور کار می‌کنه؟</h2>
            </div>
            <ol className="steps">
                <li>وارد پنل تبلیغات «ده‌وند» شو و برای تبلیغ کسب‌وکارت درخواست ثبت کن.</li>
                <li>روزهایی که می‌خوای تبلیغت نمایش داده بشه رو انتخاب کن.</li>
                <li>کار تمامه! بقیه‌اش با ما؛ تبلیغت توی روزهای انتخابی در گوشی همهٔ اهالی نمایش داده می‌شه.</li>
            </ol>

            <div className="title" style={{ marginTop: 50 }}>
                <small>راهنمای تصویری</small>
                <h2>چگونه تبلیغ خودت رو ثبت کنی؟</h2>
                <p>اول نرم‌افزار ده‌وند رو نصب کن، بعد مطابق تصاویر زیر تبلیغت رو ثبت کن.</p>
            </div>
            <PhotoProvider>
                <div className="guide">
                    {guideImages.map((src, i) => (
                        <PhotoView key={i} src={src}><img src={src} alt={`مرحله ${i + 1}`} /></PhotoView>
                    ))}
                </div>
            </PhotoProvider>
        </div>
    </section>
)

export default AdvertisingDescription
